<template>
  <div>
    <div class="div-btn-create">
      <Button _key="btnPatrimonyCreate" title="Patrimônio" classIcon="fas fa-plus-circle" type="primary" size="small"
        :clicked="create" />
    </div>
    <div class="rfid-table">
      <div class="rfid-table-tools">
        <div class="rfid-tools-left">
          <input v-model="searchTerm" type="text" class="rfid-search-input" placeholder="Pesquisar..." />
        </div>
      </div>
      <div class="side-by-side rfid-div-filter" v-if="rfid">
        <div class="side-by-side">
          <CheckboxSimple title="Com Tag RFID" :markFormDirty="false" v-model="showWithRfid" />
        </div>

        <div class="side-by-side rfid-div-check-sem-rfid">
          <CheckboxSimple title="Sem Tag RFID" :markFormDirty="false" v-model="showWithoutRfid" />
        </div>
      </div>
      <div class="rfid-div-total side-by-side text-center">
        Total <b>
          {{ items.length }}
        </b> registros
      </div>


      <div class="rfid-table-header">
        <div class="col-check">
          <b-form-checkbox v-model="selectAll" @change="select" />
        </div>
        <div class="col-pat">Nº Patrimônio</div>
        <div v-if="rfid" class="col-rfid">Nº Tag RFID</div>
        <div class="col-serial">Nº Série</div>
        <div class="col-status text-center">Status</div>
        <div class="col-history"></div>
      </div>
      <div class="rfid-row" v-for="item in filteredList" :key="item.id">
        <div class="col-check">
          <b-form-checkbox v-model="selected" :value="item.id" />
        </div>
        <div class="col-pat">
          <span class="pat-pill">{{ item.barCode }}</span>
        </div>

        <div v-if="rfid" class="col-rfid">
          <span v-if="item.rfid" class="rfid-pill">{{ item.rfid }}</span>
        </div>

        <div class="col-serial">
          <span v-if="item.serialNumber" class="serial-pill">{{ item.serialNumber }}</span>
        </div>

        <div class="col-status text-center">
          <span :class="['status-pill', getStatusClass(item.statusName)]">
            {{ item.statusName }}
          </span>
        </div>

        <div class="col-history">
          <Button :_key="'btnEdit' + item.id" type="edit" size="small" classIcon="fa-solid fa-marker"
            :clicked="() => openEdit(item)" />
          <Button :_key="'btnHistory' + item.id" type="info" size="small" classIcon="fa-solid fa-clock-rotate-left"
            :clicked="() => openHistory(item)" />
        </div>
      </div>

      <div class="text-center" v-if="filteredList.length === 0">
        <br>
        Nenhum registro encontrado!
      </div>

    </div>
    <Modal title="Patrimônio" :width="900" :height="750" v-show="showModal('patrimonyCreateUpdate')">
      <PatrimonyCreateUpdate :productId="productId" />
    </Modal>
    <Modal title="Histórico de Movimentação" :width="750" :height="750" v-show="showModal('historyPatrimony')">
      <HistoryPatrimony />
    </Modal>

    <BottomActionsBar :selected="selected" @close="addSelected([])">
      <ActionsSelected :selected="selected" :actions="actions" />
    </BottomActionsBar>
  </div>
</template>

<script>

import ActionsSelected from "@nixweb/nixloc-ui/src/component/shared/actions/ActionsSelected.vue";
import BottomActionsBar from "@nixweb/nixloc-ui/src/component/layout/BottomActionsBar.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import PatrimonyCreateUpdate from './PatrimonyCreateUpdate.vue'
import HistoryPatrimony from '../history-patrimony/HistoryPatrimony.vue'

import { mapMutations, mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "StaticPatrimonyList",
  components: { ActionsSelected, BottomActionsBar, CheckboxSimple, Button, Modal, PatrimonyCreateUpdate, HistoryPatrimony },
  props: {
    productId: String,
  },
  data() {
    return {
      urlGetApi: "/api/v1/stock/patrimony/get-all",
      rfid: true,
      searchTerm: "",
      showWithRfid: true,
      showWithoutRfid: true,
      selectAll: false,
      items: [],
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/stock/patrimony/delete", method: "delete", },
      ],
    };
  },
  mounted() {
    this.getAll();
    this.rfid = this.hasRule('RFID');
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapGetters("user", ["hasRule"]),
    ...mapState("generic", ["selected"]),
    selected: {
      get() {
        return this.$store.state.generic.selected;
      },
      set(value) {
        this.addSelected(value);
      },
    },
    filteredList() {
      let list = [...this.items];

      if (this.rfid) {
        if (this.showWithRfid && !this.showWithoutRfid) {
          list = list.filter(p => p.rfid);
        } else if (!this.showWithRfid && this.showWithoutRfid) {
          list = list.filter(p => !p.rfid);
        } else if (!this.showWithRfid && !this.showWithoutRfid) {
          list = [];
        }
      }

      if (this.searchTerm) {
        const t = this.searchTerm.toLowerCase();
        list = list.filter(p => {
          return (
            (p.barCode || "").toLowerCase().includes(t) ||
            (p.rfid || "").toLowerCase().includes(t) ||
            (p.serialNumber || "").toLowerCase().includes(t)
          );
        });
      }
      return list;
    },
  },
  methods: {
    ...mapMutations("generic", ["addSelected", "openModal", "addEvent", "removeLoading"]),
    ...mapActions("generic", ["getApi", "deleteAllApi"]),
    getAll() {
      this.loading = true;
      let params = {
        url: this.urlGetApi,
        obj: {
          any: this.productId,
        },
      };
      this.getApi(params).then((response) => {
        this.items = response.content.data;
        this.loading = false;
      });
    },
    select() {
      this.addSelected([]);
      if (this.selectAll) {
        for (let i in this.items) {
          this.selected.push(this.items[i].id);
        }
      }
    },
    create() {
      this.openModal("patrimonyCreateUpdate");
      this.addEvent({ name: "patrimonyCreate" });
      this.removeLoading(["btnPatrimonyCreate"]);
    },
    openEdit(item) {
      this.addEvent({ name: "updatePatrimony", data: item });
      let itemId = "btnEdit" + item.id;
      this.removeLoading([itemId]);
      this.openModal("patrimonyCreateUpdate");
    },
    openHistory(item) {
      this.addEvent({ name: "historyPatrimony", data: item });
      let itemId = "btnHistory" + item.id;
      this.removeLoading([itemId]);
      this.openModal("historyPatrimony");
    },
    getStatusClass(statusName) {
      switch (statusName) {
        case "Disponível": return "status-disponivel";
        case "Locado": return "status-locado";
        case "Inativo": return "status-inativo";
        case "Manutenção": return "status-manutencao";
        default: return "";
      }
    }
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "actionsUpdated" || event.name == "patrimonyUpdated") this.getAll();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.rfid-table {
  margin-top: 10px;
}

.rfid-table-tools {
  padding: 0px 18px 0 18px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.rfid-div-check-sem-rfid {
  margin-left: 20px;
}

.rfid-tools-left {
  flex: 1;
}

.rfid-search-input {
  width: 100%;
  padding: 5px 10px;
  font-size: 13px;
  border-radius: 50px;
  border: 1px solid #e5e4e8;
}

.rfid-div-filter {
  margin: 15px 10px 15px 25px;
}

.rfid-table-header {
  display: flex;
  padding: 12px 18px;
  background: #f9fafb;
  border-bottom: 1px solid #eef0f3;
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
}

.rfid-row {
  display: flex;
  padding: 14px 18px;
  border-bottom: 1px solid #f3f4f6;
  align-items: center;
}

.col-check {
  width: 50px;
}

.col-pat {
  width: 280px;
}

.col-rfid {
  width: 280px;
}

.col-serial {
  width: 220px;
}

.col-status {
  width: 150px;
}

.col-history {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.rfid-div-total {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e6e7eb;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  margin-bottom: 10px;
  width: 150px;
  display: block;
  margin-left: auto;
}

.pat-pill {
  background: #e0e7ff;
  color: #4338ca;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
}

.rfid-pill {
  background: #f3f4f6;
  color: #374151;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 13px;
}

.serial-pill {
  background: #e5e7eb;
  color: #1f2937;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 13px;
}

.status-pill {
  padding: 3px 14px;
  border-radius: 14px;
  font-size: 12px;
  color: #fff;
  text-transform: capitalize;
}

.status-disponivel {
  background: #38A169;
}

.status-locado {
  background: #0008AA;
}

.status-inativo {
  background: red;
}

.status-manutencao {
  background: #FFC106;
}

.div-btn-create {
  margin-bottom: 30px;
}
</style>
